// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__3BLIf","whiteThemeText":"Tag_whiteThemeText__3rO26","text":"Tag_text__OpmMp","fadeIn":"Tag_fadeIn__30OBS","fadeOut":"Tag_fadeOut__2pcrm"};